import * as yup from 'yup';

export default yup.object({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  reference: yup.string().notRequired().nullable(),
  mobile: yup.string().required(),
});
